import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageHeader }     from "@/components/shared/PageHeader";
import { EventoForm }     from "@/features/calendar";
import { useCreateEvento } from "@/features/calendar";
import type { CalendarEventCreate } from "@cold-crew/shared";

export const Route = createFileRoute("/_app/calendario/nuevo")({
  component: NuevoEventoPage,
});

function NuevoEventoPage() {
  const navigate      = useNavigate();
  const createEvento  = useCreateEvento();

  async function handleSubmit(data: CalendarEventCreate) {
    await createEvento.mutateAsync(data);
    navigate({ to: "/calendario" });
  }

  return (
    <div className="p-6 max-w-2xl mx-auto space-y-6">
      <PageHeader
        title="Nuevo evento"
        description="Agrega un evento o recordatorio al calendario."
      />
      <div className="rounded-lg border border-border bg-card p-6">
        <EventoForm
          onSubmit={handleSubmit}
          isLoading={createEvento.isPending}
          submitLabel="Crear evento"
        />
      </div>
    </div>
  );
}
